<!--
 * @Author: fangzhi fangzhi@vivo.com
 * @Date: 2023-09-12 16:32:54
 * @LastEditors: tianyuhan
 * @LastEditTime: 2024-07-18 11:48:53
 * @FilePath: /h5/src/components/header-menu/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <!-- <div class="header-menu" v-show="isShowMenu">
    <div class="overlay" @click.stop="close"></div>
    <div :class="['mod-nav', isShowMenu ? 'show' : '']" v-statusBarHeight="'margin-top'">
      <div class="item home" @click="toHome">首页</div>
      <div class="item buy" @click="toNav">选购商品</div>
      <div class="item center" @click="toMy">个人中心</div>
      <div class="item concat" @click="toConnect">在线客服</div>
    </div>
  </div> -->
  <nx-dropdown-menu  
    v-model="value" 
    :show="isShowMenu" 
    :list="menuList" 
    popPosition="right"
    type="normal" 
    @change="handleSelectMenu"
  >
    <template v-slot:menuIcon>
      <div class="icon menu" role="button" tabindex="0" aria-label="菜单">
        <v-icon class="i-menu" name="icon-menu-v3"></v-icon>
      </div>
    </template>
  </nx-dropdown-menu>
</template>

<script>
import create from '../create'
import { jumpToHome, jumpToNav, jumpToMy, jumpToKeFu } from 'utils/common'
import { DropdownMenu  } from '@vivo/vos-ui';
export default create({
  name: 'headerMenu',
  // props: {
  //   isShowMenu: {
  //     type: Boolean,
  //     default: false
  //   }
  // },
  data() {
    return {
      value: '',
      isShowMenu: false,
      menuList: [{
        value: 'toHome',
        text: '首页'
      },{
        value: 'toNav',
        text: '选购商品'
      },{
        value: 'toMy',
        text: '个人中心'
      },{
        value: 'toConnect',
        text: '在线客服'
      }]
    }
  },
  components: {
    [DropdownMenu.name]: DropdownMenu
  },
  watch: {
    // 防止滚动穿透
    isShowMenu(val) {
      this.value = ''
      // document.body.style.overflow = val ? 'hidden' : 'auto'
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    handleSelectMenu(value, item){
      this.$nextTick(()=>{
        this[value]&& this[value]()
      })
    },
    toHome() {
      jumpToHome()
    },
    toNav() {
      jumpToNav()
    },
    toMy() {
      jumpToMy()
    },
    toConnect() {
      jumpToKeFu()
    }
  },
  // 售后&维修 使用keepalive导致页面切换之后下拉菜单闪现
  activated() {
    const el = document.querySelector('.nx-dropdown-menu-content-list')
    if(el){
      el.style = {}
    }
  },      
  deactivated() {},
  beforeDestroy() {
    document.body.style.overflow = 'auto'
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
